(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$.getJSON(config.AJAX_URL, {action: 'sleek_get_stock'}, function (data) {
		// JSON Version = && data.data.length, data = data.data[0]
		if (data && data.data) {
			data = data.data;

			$('[data-stock]').each(function () {
				var wrap = $(this);

				for (var i in data) {
					// This if is only for JSHint :/
					if (i) {
						var key = i.toLowerCase();
						var el = wrap.find('[data-stock-' + key + ']');

						if (el.length) {
							el.html(data[i]);
						}
					}
				}
			});
		}
	});
})();
